
import { Component, Mixins } from "vue-property-decorator";
import { ITooltipBehavior } from "../../../../../../documaker/domain/format/objects";
import { ITooltipBehaviorPropertyEditable, instanceOfITooltipBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class TooltipBehaviorPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ITooltipBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ITooltipBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isTooltipBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfITooltipBehaviorPropertyEditable(s) && s.tooltipBehavior().isEditable(), false);
  }

  get tooltipBehavior(): ITooltipBehavior {
    return this.readPropertyOrDefault(s => s.tooltipBehavior().getValue(), { message: "", isEnable: false });
  }

  set tooltipBehavior(value: ITooltipBehavior) {
    this.writePropertyWhenValid(s => s.tooltipBehavior().setValue(value));
  }
}
